import { make } from 'vuex-pathify';
import { state as configuration } from '@/store/configuration';

const mutations = {
  ...make.mutations(configuration),
};

export { mutations };
